/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect }from 'react'
import {Card, Row, CardHeader, Col, Badge, CardBody} from "reactstrap";
import Loading from '../../lib/loading'
import {Card_p, Card_g} from "./CardHome.js";
import LinhaCard from "../../components/Graficos/LinhaCard-cores";
import imagem_primeiro from "../../assets/img/grafico_faturamento/primeiro.png";
import imagem_segundo from "../../assets/img/grafico_faturamento/segundo.png";
import imagem_terceiro from "../../assets/img/grafico_faturamento/terceiro.png";
import imagem_outros from "../../assets/img/grafico_faturamento/outros.png";

const Home = ({loading, lista, title, color, component}) => {

  const [dadosDiaHora, setDadosDiaHora] = useState([])
  const [diaSemana, setdiaSemana] = useState("")
  const [clicou, setClicou] = useState(false);
  // const [listaDiario, setListaDiario] = useState([])


  // setListaDiario(lista['dia'])
  
  var litsaSemana = lista['semana'],
      listaDiario = lista['dia']


  const DadosDia  = () => {

   
    setDadosDiaHora([])

    if (listaDiario && listaDiario.length) {
      // console.log('dados dia - priemiro if')

      for (let i = 0; i < listaDiario.length; i++) {
        // console.log('dados dia - percorrendo for')

        if (listaDiario[i]['dia'] === diaSemana) {
          setDadosDiaHora(listaDiario[i])
        }
      }    
    }else{
      setDadosDiaHora([])
    }
  }
 
  useEffect(() => {
    DadosDia()
  }, [lista]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // console.log('useeffect dia da semana')
    DadosDia()
  }, [diaSemana]) // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return (
      <div>
        <Card>
          <Loading
            tipo='componente'
          />
        </Card>
      </div>
    )
  }

  return (
    <>
      <Card className="p-0 mt-3">
      <CardHeader>
        <Row>
          <Col sm="7">
            {/* <div className="numbers pull-left grafico-valor">Período {data_inicio + ' a ' + data_final}</div> */}
          </Col>
          <Col sm="5">
            <div className="pull-right">
              <Badge className="text-blue" pill>
                Faturamento Semanal
              </Badge>
            </div>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <Row>
          {/* { 
            lista.map((item, i) => (
              <Card_m
                key = {i}
                cor='text-warning'
                icone='fa-calendar'
                valor={item.valor}
                titulo={item.dia}
                porcentagem={item.porcentagem}
              />
            ))
          }
        </Row> */}

          <Card_p
            cor='text-warning'
            imagem={imagem_segundo}
            altura='py-3'
            icone='fa-calendar'
            valor={(litsaSemana.length)?litsaSemana[1].valor:''}
            titulo={(litsaSemana.length)?litsaSemana[1].dia:'Sem movimento'}
            porcentagem={(litsaSemana.length)?litsaSemana[1].porcentagem+'%':0+'%'}
            click = {setdiaSemana}
            clicou = {clicou}
            setClicou = {setClicou}
          />

          <Card_g
            cor='text-danger'
            imagem={imagem_primeiro}
            icone='fa-calendar'
            valor={(litsaSemana.length)?litsaSemana[0].valor:''}
            titulo={(litsaSemana.length)?litsaSemana[0].dia:'Sem movimento'}
            porcentagem={(litsaSemana.length)?litsaSemana[0].porcentagem+'%':0+'%'}
            click = {setdiaSemana}
            clicou = {clicou}
            setClicou = {setClicou}
          />

          <Card_p
            cor='text-warning'
            imagem={imagem_terceiro}
            icone='fa-calendar'
            valor={(litsaSemana.length)?litsaSemana[2].valor:''}
            titulo={(litsaSemana.length)?litsaSemana[2].dia:'Sem movimento'}
            porcentagem={(litsaSemana.length)?litsaSemana[2].porcentagem+'%':0+'%'}
            click = {setdiaSemana}
            clicou = {clicou}
            setClicou = {setClicou}
          />
        </Row>
        <Row>
          <Card_p
            cor='text-blue'
            imagem={imagem_outros}
            icone='fa-calendar'
            valor={(litsaSemana.length)?litsaSemana[3].valor:''}
            titulo={(litsaSemana.length)?litsaSemana[3].dia:'Sem movimento'}
            porcentagem={(litsaSemana.length)?litsaSemana[3].porcentagem+'%':0+'%'}
            click = {setdiaSemana}
            clicou = {clicou}
            setClicou = {setClicou}
          />

          <Card_p
            cor='text-blue'
            imagem={imagem_outros}
            icone='fa-calendar'
            valor={(litsaSemana.length)?litsaSemana[4].valor:''}
            titulo={(litsaSemana.length)?litsaSemana[4].dia:'Sem movimento'}
            porcentagem={(litsaSemana.length)?litsaSemana[4].porcentagem+'%':0+'%'}
            click = {setdiaSemana}
            clicou = {clicou}
            setClicou = {setClicou}
          />

          <Card_p
            cor='text-blue'
            imagem={imagem_outros}
            icone='fa-calendar'
            valor={(litsaSemana.length)?litsaSemana[5].valor:''}
            titulo={(litsaSemana.length)?litsaSemana[5].dia:'Sem movimento'}
            porcentagem={(litsaSemana.length)?litsaSemana[5].porcentagem+'%':0+'%'}
            click = {setdiaSemana}
            clicou = {clicou}
            setClicou = {setClicou}
          />

          <Card_p
            cor='text-blue'
            imagem={imagem_outros}
            icone='fa-calendar'
            valor={(litsaSemana.length)?litsaSemana[6].valor:''}
            titulo={(litsaSemana.length)?litsaSemana[6].dia:'Sem movimento'}
            porcentagem={(litsaSemana.length)?litsaSemana[6].porcentagem+'%':0+'%'}
            click = {setdiaSemana}
            clicou = {clicou}
            setClicou = {setClicou}
          />
      </Row>
      </CardBody>

      <LinhaCard
        title='teste'
        color='red'
        lista = {dadosDiaHora}
        dia = {diaSemana}
      />
      
      </Card>
      
    </>
  )
}

export default Home
